export default __webpack_public_path__ + "static/media/nodejs.c1a310ac.svg";